import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = ['Dolor que nadie sabe explicarte — y menos cómo corregirlo', 'Pecho blando y ya creés que "se fue la leche"', 'El bebé llora y no sabés si es hambre, brote o algo peor', 'El brote de las 6 semanas que te destruyó sin aviso', 'La mamadera que empezaste "solo esta vez" y no pudiste sacar', 'La culpa de no poder. El agotamiento de no saber.'];
export function PainPoints() {
  return <section className="py-20 px-4" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-157">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-cream-light mb-6" data-id="element-158">
            ¿Cuántas noches más vas a pasar así?
          </h2>
          <p className="text-xl text-brand-primary" data-id="element-159">
            Querés amamantar. Lo intentás con todo. Pero nadie te dio un
            sistema.
          </p>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-160">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-4 bg-brand-darker/50 p-5 rounded-xl border border-red-900/20" data-id="element-161">
              <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-162" />
              <p className="text-lg text-brand-cream" data-id="element-163">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-164">
          <p className="text-2xl md:text-3xl font-serif text-brand-accent italic" data-id="element-165">
            ¿Y si esta fuera la última noche que pasás así?
          </p>
        </motion.div>
      </div>
    </section>;
}